export interface IStorage {
  set: (key: string, value: string | Array<any> | object) => void
  get: (key: string) => string | Array<any> | object
  remove: (key: string) => void
  clear: () => void
}

const storage = {
  set: (key: string, value: string | Array<any> | object) => {
    const stringify = JSON.stringify(value)
    localStorage.setItem(key, stringify)
  },

  get: (key: string) => {
    const value = localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) || '') : null
    return value
  },

  remove: (key: string) => {
    localStorage.removeItem(key)
  },

  clear: () => {
    localStorage.clear()
  },
}

export default storage
